import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import * as UserStore from '../../app/store/UserStore';
import Auth, { authTypes } from '../../youwell-common/Auth';

const TrackedLink = ({
    endId,
    patientProgramId,
    patientProgramElementId,
    taskId,
    moduleId,
    label,
    forwardedRef,
    ...rest
}) => {
    const dispatch = useDispatch();
    const patientId = useSelector(state => state.auth.profileData?.id);
    const actualPatientProgramId = useSelector(state => patientProgramId || state.programStore.currentProgram?.id);

    const sendActivity = () => {
        if (Auth.isUserAuthenticated(authTypes.user, authTypes.public, authTypes.orgSelect)) {
            dispatch(UserStore.actionCreators.sendActivity({
                endId,
                pid: patientId,
                ppid: actualPatientProgramId,
                ppeid: patientProgramElementId,
                tid: taskId,
                mid: moduleId,
                l: label,
                start: new Date(),
            }));
        }
    };

    if (!rest.to) {
        return (<div ref={forwardedRef} className={rest.className}>{rest.children}</div>);
    }

    // Pass all remaining props for material-ui focus effects etc...
    return <Link ref={forwardedRef} {...rest} onClick={sendActivity} />;
};

TrackedLink.propTypes = {
    label: PropTypes.string.isRequired,
    to: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    className: PropTypes.string,
    endId: PropTypes.number,
    patientProgramId: PropTypes.string,
    patientProgramElementId: PropTypes.string,
    taskId: PropTypes.string,
    moduleId: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.string,
    forwardedRef: PropTypes.func,
};

TrackedLink.defaultProps = {
    children: null,
    className: null,
    endId: null,
    patientProgramId: null,
    patientProgramElementId: null,
    taskId: null,
    moduleId: null,
    style: null,
    to: null,
    title: null,
    forwardedRef: null,
};

export default React.forwardRef((props, ref) => <TrackedLink {...props} forwardedRef={ref} />);
